<style lang="less" scoped>
@import "./lqLayer.less";
</style>
<template>
  <div class="lqContainner">
    <div class="inherent">
      <div style="position:absolute;height:100%">
        <div class="Info">
          <info type='lq' />
        </div>
        <!-- <div class="progress">
          <progressM type='lq'/>
        </div> -->
        <div class="alarm">
          <alarm type='lq'/>
        </div>
        <div class="survey">
          <survey type='lq'/>
        </div>
        <div class="transportOverview">
          <transportOverview type='lq'/>
        </div>
        <div class="backconrt">
          <backconrtM type='lq'/>
        </div>
      </div>
      <div class="frontconrt" :class="onlyOneImg==1?'onlyOneImg':'notOnlyOne'">
        <frontconrtM type='lq' @onlyOne='changeImg'/>
      </div>
    </div>
  </div>
</template>
<script>
import mix from "./lqLayer-mixins";
export default {
  mixins: [mix]
};
</script>



// WEBPACK FOOTER //
// src/components/lqLayer/lqLayer.vue